export default "__VITE_ASSET__BKb8cCBf__"